var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('UserControlPanelTabs',{attrs:{"tabs":_vm.tabs,"activeConfig":_vm.state.configActive,"currentUser":_vm.state.currentUser ? _vm.state.currentUser : _vm.user},on:{"logout":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }